import {ChangeDetectionStrategy, Component, inject, Input, OnInit} from '@angular/core';
import { filter, firstValueFrom } from "rxjs";
import {
  HardwareManagementKtostammStandortStore,
  SOFTLINE_FEATURE_HARDWARE_MANAGEMENT_KTOSTAMM_STANDORT,
} from '../../../hardware-management.shared';
import { map } from "rxjs/operators";
import {UntypedFormControl, UntypedFormGroup, FormGroupDirective, ReactiveFormsModule} from '@angular/forms';
import {
  MessageBarStore,
  SOFTLINE_FEATURE_MESSAGE_BAR,
  Validators,
} from '@softline/ui-core';
import { EntityInputComponent } from '@softline/ui-core/entity-input';
import {Store} from '@softline/core';
import {showRequestErrors} from '@softline/application';
import {HardwareTyp} from '../../../types/hardware-typ';
import {CommonModule} from '@angular/common';
import {InputBaseComponent} from '../../input-base/input-base.component';
import { EntityListDataView } from "@softline/dynamic";
import { UserInfoService } from '@softline/auth';
import { SoftAppsUserInfo } from '@softapps/core';
import { SOFTLINE_FEATURE_UTILITIES_ACCOUNT, UtilitiesAccountStore } from '@softapps/allgemein/utils';
import { DynamicModule } from "@softline/dynamic";
import { KtostammStandort, KtostammStandortFieldOk } from '../../../types/ktostamm-standort';

import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'soft-ktostamm-standort-input',
    imports: [CommonModule, InputBaseComponent, ReactiveFormsModule,
    TranslatePipe],
    templateUrl: './ktostamm-standort-input.component.html',
    styleUrls: ['./ktostamm-standort-input.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KtostammStandortInputComponent {
  private readonly parentFormGroup = inject(FormGroupDirective);
  private readonly store = inject(Store);
  private readonly userInfo = inject<UserInfoService<SoftAppsUserInfo>>(UserInfoService);

  @Input() readonly = false;
  @Input() required = false;

  readonly standorte$ = this.store.observe(
    SOFTLINE_FEATURE_HARDWARE_MANAGEMENT_KTOSTAMM_STANDORT,
    HardwareManagementKtostammStandortStore.getters.list
  ).pipe(map(o => o as KtostammStandortFieldOk[]));

  get formGroup(): UntypedFormGroup {
    return this.parentFormGroup.form;
  }

  async select(standort: KtostammStandortFieldOk | null | undefined): Promise<void> {
    if(!standort)
      return;

    const accountid = this.userInfo.value()?.accountid;
    const ktostamm = await firstValueFrom(
      this.store.observe(
        SOFTLINE_FEATURE_UTILITIES_ACCOUNT,
        UtilitiesAccountStore.getters.entity,
        accountid)
      .pipe(filter(o => !!o))
    );

    const ktostamm_standort = await this.store.dispatch(
      SOFTLINE_FEATURE_HARDWARE_MANAGEMENT_KTOSTAMM_STANDORT,
      HardwareManagementKtostammStandortStore.actions.load,
      {id: standort.id, params: {filter: '', multiValued: false, parameters: {kundennummer: ktostamm.number, lieferadresse: 1}}}
    );
    this.formGroup.patchValue({ ktostamm_standort });
  }

  valueChanged(newValue: KtostammStandortFieldOk | undefined | null): void {
  }

  canceled(entityInput?: EntityInputComponent<any>): void {
    this.formGroup.patchValue({ hardwaretyp: null });

    if (entityInput) {
      // remove any existing text of the input (reset)
      entityInput.onInput('');
      entityInput.input = '';
      entityInput.inputComponent.nativeElement.value = '';
    }
  }

  // We have to use an arrow-function in order to preserve `this` context
  readonly filterTypes = (types: KtostammStandortFieldOk[], filter: string): KtostammStandortFieldOk[] => {
    if (!filter || filter?.length < 1) {
      return types;
    }

    return types.filter(typ => {
      return ('' + typ['subnummer'])?.toLowerCase().includes(filter)
        || ('' + typ['11'])?.toLowerCase().includes(filter)
        || ('' + typ['3'])?.toLowerCase().includes(filter);
    });
  }
}
